import PropTypes from 'prop-types';
import {SidePanel} from 'front-onceforall-core';
import ResendReasonForm from '../../../notification/ResendReasonForm';

function ResendReasonPanelView(props) {
  let triggerClosePanel = () => {};
  return (
    <>
      {props.isOpen &&
        <SidePanel
          setCloseTrigger={closeFunction => {
            triggerClosePanel = closeFunction;
          }}
          big
          onClose={props.onClose}
        >
          <ResendReasonForm
            onClose={() => triggerClosePanel()}
            onSubmit={props.onSubmit}
          />
        </SidePanel>
      }
    </>
  );
}

ResendReasonPanelView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ResendReasonPanelView;
